import { render, staticRenderFns } from "./TabelaComponent.vue?vue&type=template&id=7e77e6a0&"
import script from "./TabelaComponent.vue?vue&type=script&lang=js&"
export * from "./TabelaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports